// Mui
import { styled } from "@mui/system";
import { Avatar } from "@mui/material";

// Utils
import { shouldForwardProp } from "utils";

type SquaredAvatarProps = {
    isDisabled?: boolean;
    hideBorder?: boolean;
    size?: number;
};

const SquaredAvatar = styled(Avatar, {
    shouldForwardProp: (prop) => shouldForwardProp<SquaredAvatarProps>(["isDisabled", "hideBorder", "size"], prop),
})<SquaredAvatarProps>(({ size, isDisabled = false, hideBorder, theme }) => ({
    backgroundColor: isDisabled ? "transparent" : theme.palette.common.white,
    color: theme.palette.primary.dark,
    width: size ?? 24,
    height: size ?? 24,
    fontSize: size ?? 24,
    backdropFilter: "blur(10px)",
    boxShadow:
        hideBorder || isDisabled
            ? "none"
            : "0px 1px 4px rgba(0, 0, 0, 0.03), 0px 5px 5px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.03)",
    "& .MuiTypography-root": {
        fontSize: "0.33em",
        fontWeight: 700,
    },
}));

export default SquaredAvatar;
